export default class Api {
	static token = '==== API TOKEN ===='

	static setToken(token: string) {
		this.token = token
	}
}